import * as React from 'react';
import * as AdyenCheckout from '@adyen/adyen-web';
import * as elog from '@reverbdotcom/commons/dist/elog';
import { useAdyenEnvironment, useFiveDigitLocale } from '../lib/adyen';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';

// In compliance with PSD2 onward,
// 3DS is one of many implementations of
// Secure Customer Authentication (SCA)
export type SCAType =
 | 'threeDS2Fingerprint'
 | 'threeDS2Challenge';

interface FingerprintData {
  details: { 'threeds2.fingerprint': string };
  paymentData: string;
}

interface ChallengeResultData {
  details: { 'threeds2.challengeResult': string };
  paymentData: string;
}

export interface SCAState {
  data: FingerprintData | ChallengeResultData;
}

// For configuration see https://docs.adyen.com/online-payments/3d-secure/native-3ds2/web-component
export function useAdyenSCA({ selector, action, onAdditionalDetails }:
{ selector: string; action: PaymentAction, onAdditionalDetails(state:SCAState): void },
) {
  const locale = useFiveDigitLocale();
  const { environment, clientKey } = useAdyenEnvironment();

  React.useEffect(() => {
    function onError(error) {
      elog.error('use_adyen_sca_error', { actionType: action.type, ...error }, error.errorCode);
    }

    // @ts-ignore 2351 AdyenCheckout is constructable
    const checkout = new AdyenCheckout({
      clientKey,
      environment,
      locale,
      onAdditionalDetails,
      onError,
    });

    function options() {
      if (action.type === 'threeDS2Challenge') {
        return { size: '05' };
      }
      return {};
    }

    checkout.createFromAction(action, options()).mount(selector);
  }, [locale, selector, environment, clientKey, action, onAdditionalDetails]);
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/adyen_sca_hook.ts